import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import '@maersk-global/mds-components-core/mc-button';
import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-icon';
import '@maersk-global/mds-components-core/mc-checkbox';
import '@maersk-global/mds-components-core/mc-checkbox-group';
import '@maersk-global/mds-components-core/mc-pagination';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-option';
import '@maersk-global/mds-components-core/mc-select-native';
import '@maersk-global/mds-components-core/mc-tooltip';
import '@maersk-global/mds-components-core/mc-loading-indicator';
import '@maersk-global/mds-components-core/mc-modal';
import '@maersk-global/mds-components-core/mc-input-date';
import '@maersk-global/mds-components-core/mc-multi-select';
import '@maersk-global/mds-components-core/mc-multi-select-native';
import '@maersk-global/mds-components-core/mc-typeahead';
import '@maersk-global/mds-components-core/mc-typeahead-multi-select';
import '@maersk-global/mds-components-community/mc-c-tag-multiselect';
import '@maersk-global/mds-components-core/mc-radio-group';
import '@maersk-global/mds-components-core/mc-radio';
import '@maersk-global/mds-components-core/mc-textarea';
import '@maersk-global/mds-components-core/mc-toast';
import '@maersk-global/mds-components-core/mc-notification';
import '@maersk-global/mds-components-core/mc-tab-bar';
import '@maersk-global/mds-components-core/mc-tab';
import '@maersk-global/mds-components-core/mc-icon';
import '@maersk-global/mds-components-community/mc-c-accordion-item';
import '@maersk-global/mds-components-core/mc-text-and-icon';
import '@maersk-global/mds-components-core-drawer';
import '@maersk-global/mds-components-core-button';
import '@maersk-global/mds-components-core-modal';
import '@maersk-global/mds-components-core-input-date';
import '@maersk-global/mds-components-core-file-upload';

@Component({
  selector: 'app-mds-components',
  standalone: true,
  imports: [],
  template: '',
  styles: '',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MdsComponentsComponent {

}
